/**
 * Strips slashes from the ends of a string with index scans, not a regex, so
 * a long run of slashes cannot cause super-linear backtracking.
 */
function trimSlashes(value: string, leading: boolean): string {
  let start = 0;
  let end = value.length;
  while (leading && start < end && value[start] === '/') {
    start++;
  }
  while (end > start && value[end - 1] === '/') {
    end--;
  }
  return value.slice(start, end);
}

/**
 * Builds the root of the CRM gateway route that the agent-inbox MFEs call for
 * customer notes: `${apiUrl}/bffproxy/${prefix}`.
 *
 * The prefix is trimmed of whitespace and surrounding slashes, and `apiUrl` of
 * trailing slashes, so a stray slash in config cannot double up in the path.
 *
 * @param apiUrl The API base URL (`environment.API_URL`).
 * @param prefix The per-environment gateway prefix (`environment.CRM_BFF_PREFIX`).
 * @returns The path, or `undefined` when the prefix is empty, so an environment
 * with nothing configured sends the MFEs no path at all.
 */
export function buildCrmApiPath(
  apiUrl: string,
  prefix: string,
): string | undefined {
  const cleanPrefix = trimSlashes(prefix.trim(), true);
  if (!cleanPrefix) {
    return undefined;
  }

  return `${trimSlashes(apiUrl, false)}/bffproxy/${cleanPrefix}`;
}
